import BaseModalTitle from './BaseModalTitle';

export default BaseModalTitle;
